import { CommonService } from '../../shared/core.index';
import { Injectable } from '@angular/core';
import { ApiHandlerService } from '../../shared/service/api-handler/api-handler.service';
import { Observable } from 'rxjs';
import { ConfigEditResponse, ConfigItem, ConfigPayload } from '../../shared/models/config.model';

@Injectable({
  providedIn: 'root',
})
export class VmsService {
  constructor(private commonService: CommonService, private apiHandlerService: ApiHandlerService) { }

  // Example menu data for the VMS sidebar
  private sidebarData = [
    {
      title: 'Dashboard',
      hasSubRoute: false,
      hideInFrame: false,
      icon: '<i class="fa-solid fa-box-archive"></i>',
      route: '/vms/dashboard',
      allowed_roles: [],
    },
    // {
    //   title: 'My Dashboard',
    //   hasSubRoute: false,
    //   hideInFrame: false,
    //   icon: '<i class="fa-solid fa-table-columns"></i>',
    //   route: '/vms/mydashboard',
    //   allowed_roles: [],
    // },
    {
      title: 'Frontdesk',
      hasSubRoute: false,
      hideInFrame: true,
      icon: '<i class="fa-regular fa-user"></i>',
      route: '/vms/frontdesk',
      allowed_roles: [],
    },
    {
      title: 'My Invitations',
      hasSubRoute: false,
      hideInFrame: false,
      icon: '<i class="fa-solid fa-calendar-days"></i>',
      route: '/vms/invitations',
      allowed_roles: [],
    },
    {
      title: 'My Visitors',
      hasSubRoute: false,
      hideInFrame: false,
      icon: '<i class="fa-solid fa-users"></i>',
      route: '/vms/visitors',
      allowed_roles: [],
    },
    {
      title: 'Force Checkout',
      hasSubRoute: false,
      hideInFrame: false,
      icon: '<i class="fa fa-sign-out"></i>',
      route: '/vms/force-checkout',
      allowed_roles: ['vms-force-checkout'],
    },
    {
      title: 'Reports',
      hasSubRoute: true, // Indicates that this menu has sub-routes
      icon: '<i class="fa-solid fa-chart-line"></i>',
      route: '/vms/reports/visitor-report',
      showSubRoute: false,
      hideInFrame: false,
      allowed_roles: ['vms-feedbackreports', 'vms-visitorreport'],
      subMenu: [
        {
          title: 'Visitor Report',
          route: '/vms/reports/visitor-report',
          icon: '<i class="fa-solid fa-users"></i>',
          allowed_roles: ['vms-visitorreport'],
          hasSubRoute: false,
          hideInFrame: false,
        },
        {
          title: 'Feedback Report',
          route: '/vms/reports/feedback-report',
          icon: '<i class="fa-solid fa-star"></i>',
          allowed_roles: ['vms-feedbackreports'],
          hasSubRoute: false,
          hideInFrame: false,
        },
        {
          title: 'Pending Checkout Report',
          route: '/vms/reports/pending-checkout-report',
          icon: '<i class="fa-solid fa-door-open"></i>',
          allowed_roles: ['vms-checkoutreport'],
          hasSubRoute: false,
          hideInFrame: false,
        },
        {
          title: 'Force Checkout Report',
          route: '/vms/reports/force-checkout-report',
          icon: '<i class="fa-solid fa-file-circle-xmark"></i>',
          allowed_roles: ['vms-force-out-report'],
          hasSubRoute: false,
          hideInFrame: false,
        },
        {
          title: 'Time Spent Report',
          route: '/vms/reports/time-spent-report',
          icon: '<i class="fa-solid fa-clock"></i>',
          allowed_roles: ['vms-timespentreport'],
          hasSubRoute: false,
          hideInFrame: false,
        },
      ],
    },
    // {
    //   title: 'Setting',
    //   hasSubRoute: true, // Indicates that this menu has sub-routes
    //   icon: '<i class="fa-solid fa-gear"></i>',
    //   route: '/vms/setting',
    //   showSubRoute: false,
    //   allowed_roles: [],
    //   subMenu: [
    //     {
    //       title: 'Config',
    //       route: '/vms/setting/config',
    //       icon: '<i class="fa-solid fa-sliders"></i>', // Optional icon for the submenu
    //       allowed_roles: [], // Define roles if needed
    //     },
    //   ],
    // },
  ];


  getSidebarData() {
    // CommonService will filter based on permissions
    this.commonService.setMenuItem(this.sidebarData);
    return this.sidebarData;
  }

  getConfig(): Observable<ConfigItem[]> {
    return this.apiHandlerService.doGet<ConfigItem[]>('api/admin/config', true, true);
  }

  updateConfig(data: ConfigPayload): Observable<ConfigEditResponse> {
    return this.apiHandlerService.doPut<ConfigEditResponse>('api/admin/config', data, true, true);
  }

  confirmMeeting(visitorId: string): Observable<any> {
    return this.apiHandlerService.doPut<any>(`api/vms/visitor/visits/${visitorId}/confirm_meeting`, {}, true, true);
  }

  getVisitorById(visitorId: string): Observable<any> {
    const url = `api/vms/visitor/visits/${visitorId}`;
    return this.apiHandlerService.doGet<any>(url, true, true);
  }

}
